import Vue from 'vue';

import Gallery from './components/Gallery.vue';

Vue.component('arterra-gallery', Gallery);

import Quotes from './components/Quotes.vue';

Vue.component('arterra-quotes', Quotes);

const app = new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/assets/js/package.js